import React from "react";
import TickCircleIcon from "@nokia-csf-uxr/ccfk-assets/latest/TickCircleIcon";
import CloseCircleIcon from "@nokia-csf-uxr/ccfk-assets/latest/CloseCircleIcon";
import TruckIcon from "@nokia-csf-uxr/ccfk-assets/latest/TruckIcon";

export const BREADCRUMB_ACTIONS = [
  {
    id: "my_cases",
    name: "My cases",
  },
  {
    id: "favourites",
    name: "Favourites",
  },
];

export const FILTER_TOOLBAR_TABS = [
  {
    id: "DOTOffers",
    name: "DOT offers",
  }
];

export const OFFER_SORT_OPTIONS = [
  {
    key: "-createdAt",
    value: "Created date",
  },
  {
    key: "total_boq_price",
    value: "Price (low to high)",
  },
  {
    key: "-total_boq_price",
    value: "Price (high to low)",
  }
];

export const OFFER_STTATUS = [
  {
    id: "draft",
    name: "Draft",
    avatar: "D",
    color: "var(--color-status-fault)",
    className: "dsh-offer-status-draft",
    // --color-status-fault: #c7cdd6;
  },  
  {
    id: "pendingapproval",
    name: "Pending approval",
    avatar: "PA",
    color: "var(--color-status-major)",
    className: "dsh-offer-status-pendingapproval",
    // --color-warning: #f7b737;
  },
  {
    id: "approved",
    name: "Approved",
    avatar: "A",
    color: "var(--color-status-success)",
    className: "dsh-offer-status-approved",
    // --color-status-success: #25b04d;
  },
  {
    id: "order",
    name: "Order",
    avatar: "O",
    color: "var(--color-brand-primary-dark)",
    className: "dsh-offer-status-order",
    // --color-info-dark
    // --color-brand-primary-dark: #005aff;
  },
  {
    id: "requesteddelivery",
    name: "Delivery requested",
    avatar: "DR",
    color: "var(--color-status-minor)",
    className: "dsh-offer-status-requesteddelivery",
  },
  {
    id: "accepteddelivery",
    name: "Delivery accepted",
    avatar: "DA",
    color: "var(--color-info)",
    className: "dsh-offer-status-accepteddelivery",
    // --color-info: #0049b4;
  },
  {
    id: "Confirmed Delivery",
    name: "Delivery confirmed",
    avatar: "DC",
    color: "var(--color-status-warning)",
    className: "dsh-offer-status-confirmed-delivery",
    // #006076
  },
  {
    id: "subscription_license_released",
    name: "Subscription & License released",
    avatar: "SLR",
    color: "var(--color-status-maintenance)",
    className: "dsh-offer-status-subscription_license_released",
  },
];

export const PAGINATION_ITEMS_PER_PAGE = [
  { key: 10, value: 10 },
  { key: 25, value: 25 },
  { key: 50, value: 50 },
  { key: 100, value: 100 },
];

export const DDQF_FLAG_MAP: Record<string, string> = {
  "MXIE 2.0 ALLOWED": "allowed",
  "MXIE 2.0 PROHIBITED": "prohibited",
  "MXIE 2.0 WITH DD": "with_dd",
};

export const DDQF_FLAG_CONFIG: Record<string, { color: string; label: string; icon: React.ComponentType<any> }> = {
  allowed: { color: "#4CAF50", label: "MXIE 2.0 ALLOWED", icon: TickCircleIcon },
  prohibited: { color: "#F44336", label: "MXIE 2.0 PROHIBITED", icon: CloseCircleIcon },
  with_dd: { color: "#2196F3", label: "MXIE 2.0 WITH DD", icon: TruckIcon },
};

